( function() {
	window.googletag = window.googletag || {};
	window.vmpbjs = window.vmpbjs || {};
	window.vpb = window.vpb || {};
	vpb.cmd = vpb.cmd || [];
	vpb.st = Date.now();
	vpb.fastLoad = true;
	googletag.cmd = googletag.cmd || [];
	vmpbjs.cmd = vmpbjs.cmd || [];
	let cmds = [];
	try {
		cmds = googletag.cmd.slice( 0 );
		googletag.cmd.length = 0;
	} catch ( e ) {} // eslint-disable-line no-unused-vars
	let ready = false;

	function exec( cb ) {
		return cb.call( googletag );
	}
	let overriden = false;
	googletag.cmd.push( function() {
		overriden = true;
		googletag.cmd.unshift = function( cb ) {
			if ( ready ) {
				return exec( cb );
			}
			cmds.unshift( cb );
			if ( cb._startgpt ) {
				ready = true;
				for ( let k = 0; k < cmds.length; k++ ) {
					exec( cmds[ k ] );
				}
			}
		};
		googletag.cmd.push = function( cb ) {
			if ( ready ) {
				return exec( cb );
			}
			cmds.push( cb );
		};
	} );
	if ( ! overriden ) {
		googletag.cmd.push = function( cb ) {
			cmds.push( cb );
		};
		googletag.cmd.unshift = function( cb ) {
			cmds.unshift( cb );
			if ( cb._startgpt ) {
				ready = true;
				if ( googletag.apiReady ) {
					cmds.forEach( function( cb ) {
						googletag.cmd.push( cb );
					} );
				} else {
					googletag.cmd = cmds;
				}
			}
		};
	}
	const dayMs = 36e5,
		cb = parseInt( Date.now() / dayMs ),
		vpbSrc = '//player.bidmatic.io/prebidlink/' + cb + '/wrapper_hb_767256_21144.js',
		pbSrc = vpbSrc.replace( 'wrapper_hb', 'hb' ),
		gptSrc = '//securepubads.g.doubleclick.net/tag/js/gpt.js',
		c = document.head || document.body || document.documentElement;

	function loadScript( src, cb ) {
		const s = document.createElement( 'script' );
		s.src = src;
		s.defer = false;
		c.appendChild( s );
		s.onload = cb;
		s.onerror = function() {
			const fn = function() {};
			fn._startgpt = true;
			googletag.cmd.unshift( fn );
		};
		return s;
	}
	loadScript( pbSrc );
	loadScript( gptSrc );
	loadScript( vpbSrc );
}() );
